import { Link, Outlet } from "react-router";

import { LogoWithTitle } from "@/site/ui/logo-with-title";
import { ThemeControl } from "@/theme/theme-control";
import { Button } from "@/ui/button";

export default function MarketingLayout() {
  const currentYear = new Date().getFullYear();

  return (
    <div className="mx-auto flex min-h-dvh w-[calc(100%-2rem)] max-w-6xl flex-col sm:w-[calc(100%-3rem)]">
      <header className="flex h-16 items-center justify-between">
        <LogoWithTitle linkTo="/" />

        <div className="flex items-center gap-2 sm:gap-3">
          <ThemeControl />
          <Button
            asChild
            className="hidden sm:inline-flex"
            size="sm"
            variant="ghost"
          >
            <Link to="/pricing">Pricing</Link>
          </Button>
          <Button asChild size="sm">
            <Link to="/login">Start a photo story</Link>
          </Button>
        </div>
      </header>

      <main className="flex flex-1 flex-col">
        <Outlet />
      </main>

      <footer className="text-muted-foreground flex flex-col items-center gap-2 border-t py-5 text-sm sm:flex-row sm:justify-between sm:pb-10">
        <p>
          © {currentYear} {publicEnv.siteTitle}. All rights reserved.
        </p>

        <div className="[&_a]:underline-decoration flex items-center gap-4 [&_a]:hover:underline">
          <Link to="/terms">Terms</Link>
          <Link to="/privacy">Privacy</Link>
        </div>
      </footer>
    </div>
  );
}
